import { shortDateTimeFormat, shortTimeFormat } from 'constants/global';

export enum EventsTab {
  All = 'all',
  Orders = 'orders',
}

export enum EventDetailsTab {
  Overview = 'overview',
  Orders = 'orders',
  Comps = 'comps',
  Tiers = 'tiers',
  People = 'people',
  Matchcard = 'matchcard',
  PresaleCodes = 'presale-codes',
  DoorLog = 'door-log',
}

export const EVENTS_PAGE_SIZE = 20;

export const DATE_TIME_PICKER_PROPS = {
  showTime: { format: shortTimeFormat, minuteStep: 5 },
  format: shortDateTimeFormat,
};

export const REFUND_POLL_INTERVAL_MS = 5000;

/** How long the orders table waits for a refund-all to start before it stops polling. */
export const BULK_REFUND_WAIT_MS = 60000;
